<template>
  <params-index
    :categories="categories"
    :costCenters="costCenters"
    :entities="entities"
    :inventoryDeletionCauses="inventoryDeletionCauses"
    :places="places"
    :updateParam="updateParam"
    :deleteParam="deleteParam"
    :admin="admin"
  />
</template>

<script>
import ParamsIndex from "@/components/ParamsIndex";

export default {
  props: [
    "categories",
    "costCenters",
    "entities",
    "inventoryDeletionCauses",
    "places",
    "updateParam",
    "deleteParam",
    "admin"
  ],
  components: {
    ParamsIndex
  }
};
</script>